module.exports = __webpack_public_path__ + "static/media/icon-ecpay.b94f3920.png";